class SubmitOnChangeDirective {
    constructor(FullPageLoaderService, SubmitOnChangeService) {
        this.restrict = 'A';
        this.loaderService = FullPageLoaderService;
        this.service = SubmitOnChangeService;
    }

    link(scope, element, attrs, controllers) {
        let debouncedTimeout = null;
        const form = element[0];
        const inputs = Array.prototype.slice.call(element.find('input'))
            .filter(element => !element.type || element.type && element.type != 'hidden' && element.type != 'submit');
        const selects = Array.prototype.slice.call(element.find('select'));
            
        if (inputs.length < 1 && selects.length < 1) return;

        let values = this.getInputValues(inputs);

        this.service.forms.push({
            form: form,
            inputs: new Map(inputs.map((input, i) => [input, values[i]]))
        });

        const onClick = () => {
            if (debouncedTimeout) {
                clearTimeout(debouncedTimeout);
                debouncedTimeout = null;
            }

            debouncedTimeout = setTimeout(() => {
                let newValues = this.getInputValues(inputs);

                if (JSON.stringify(newValues) === JSON.stringify(values)) return;

                this.loaderService.show = true;
                if (!scope.$$phase)
                    scope.$apply();
                form.submit();
            }, 1000);
        };

        for (const input of inputs) {
            angular.element(input).on('click', onClick);
        }

        const onChange = () => {
            this.loaderService.show = true;
            if (!scope.$$phase)
                scope.$apply();
            form.submit();
        };

        for (const select of selects) {
            angular.element(select).on('change', onChange);
        }

        scope.$on('$destroy', () => {
            for (const input of inputs) {
                angular.element(input).off('click', onClick);
            }

            for (const select of selects) {
                angular.element(select).off('change', onChange);
            }
        });
    }

    getInputValues(inputs) {
        return inputs.map(input => {
            const $input = angular.element(input);
            let value = null;

            switch (input.type) {
                case "checkbox":
                    value = $input.prop('checked');
                    break;
                case "radio":
                    value = $input.prop('checked');
                    break;
                case "text":
                    value = $input.val();
                    break;
            }

            return value;
        });
    }

    static directiveFactory(FullPageLoaderService, SubmitOnChangeService) {
        'ngInject';
        return new SubmitOnChangeDirective(FullPageLoaderService, SubmitOnChangeService);
    }
}

export default SubmitOnChangeDirective;